import React from "react";
import { Table, TableHead, TableCell, TableRow, TableBody } from "@material-ui/core";

import { Values } from "@src/Tools/Values";
import { STPaper } from "@src/Components/Ui/STPaperOverflow";
import { STTableHeadTypography } from "@src/Components/Ui/STTableHeadTypography";
import { Organisation } from "@src/Interfaces/Entity/Organisation";
import OrganisationTableItem from "./OrganisationTableItem/OrganisationTableItem";

interface IProps {
  organisations: Organisation[];
}

export default class OrganisationsTable extends React.Component<IProps> {
  render() {
    return (
      <STPaper elevation={2}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("name")}</STTableHeadTypography>
              </TableCell>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("description")}</STTableHeadTypography>
              </TableCell>
              <TableCell align="right" />
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.organisations.map((org: Organisation) => {
              return <OrganisationTableItem key={org.id} organization={org} />;
            })}
          </TableBody>
        </Table>
      </STPaper>
    );
  }
}
